import {
  GET_DIVISIONS_REQUEST,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILURE,
  GET_DIVISION_BY_ID_REQUEST,
  GET_DIVISION_BY_ID_SUCCESS,
  GET_DIVISION_BY_ID_FAILURE,
  GET_DIVISIONS_BY_SPORT_REQUEST,
  GET_DIVISIONS_BY_SPORT_SUCCESS,
  GET_DIVISIONS_BY_SPORT_FAILURE,
  ADD_DIVISION_REQUEST,
  ADD_DIVISION_SUCCESS,
  ADD_DIVISION_FAILURE,
  UPDATE_DIVISION_REQUEST,
  UPDATE_DIVISION_SUCCESS,
  UPDATE_DIVISION_FAILURE,
  DELETE_DIVISION_REQUEST,
  DELETE_DIVISION_SUCCESS,
  DELETE_DIVISION_FAILURE,
  SEARCH_DIVISIONS_REQUEST,
  SEARCH_DIVISIONS_SUCCESS,
  SEARCH_DIVISIONS_FAILURE,
} from "../actions/actionsCreators";

const initialState = {
  DivisionData: null,
  DivisionDetails: null,
  isLoading: false,
  error: null,
};

const divisionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DIVISIONS_REQUEST:
    case GET_DIVISION_BY_ID_REQUEST:
    case GET_DIVISIONS_BY_SPORT_REQUEST:
    case ADD_DIVISION_REQUEST:
    case UPDATE_DIVISION_REQUEST:
    case DELETE_DIVISION_REQUEST:
    case SEARCH_DIVISIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_DIVISIONS_SUCCESS:
    case GET_DIVISIONS_BY_SPORT_SUCCESS:
    case SEARCH_DIVISIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        DivisionData: action.payload,
        error: null,
      };

    case GET_DIVISION_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        DivisionDetails: action.payload,
        error: null,
      };

    case ADD_DIVISION_SUCCESS:
    case UPDATE_DIVISION_SUCCESS:
    case DELETE_DIVISION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case GET_DIVISIONS_FAILURE:
    case GET_DIVISION_BY_ID_FAILURE:
    case GET_DIVISIONS_BY_SPORT_FAILURE:
    case ADD_DIVISION_FAILURE:
    case UPDATE_DIVISION_FAILURE:
    case DELETE_DIVISION_FAILURE:
    case SEARCH_DIVISIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default divisionReducer;
